import { useQuery } from "@tanstack/react-query";
import type { Grain, ReportContext, ReportRow } from "@/lib/reports/types";
import { getResolver } from "./resolvers";

export function useReportData(metricId: string, grain: Grain, ctx: ReportContext) {
  return useQuery<ReportRow[]>({
    queryKey: ["report", metricId, grain, ctx.period, ctx.filters, ctx.drillPath],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const resolver = getResolver(metricId);
      if (!resolver) throw new Error(`Ingen resolver for ${metricId}`);
      return resolver.fetch(grain, ctx);
    },
  });
}
